import { actionTypes } from '../constants'

export const mapWasClicked = () => ({
  type: actionTypes.MAP_WAS_CLICKED,
})

export const venueMarkerWasClicked = (_id) => ({
  payload: {
    _id,
  },
  type: actionTypes.VENUE_MARKER_WAS_CLICKED,
})
